export default __webpack_public_path__ + "static/media/ESIC-1.38b41d65.jfif";